// extracted by mini-css-extract-plugin
export default {"nestedField":"nestedField---cvIMa"};